(() => {
  'use strict';
  if (window.LimitlessHomeProjects) { window.LimitlessHomeProjects.init(document); return; }
  const controllers = new Map(), plans = new Map(), servicePlans = new Map(), experiencePlans = new Map();
  const idFor = value => {
    try {
      const url = new URL(value, document.baseURI);
      const view = url.searchParams.get('view') || url.pathname.split('/').pop();
      return /^(case|note)-[a-z0-9-]+$/.test(view) ? 'lp-' + view.replace(/^(case|note)-/, '') : '';
    } catch (_) { return ''; }
  };
  const parse = node => { try { return JSON.parse(node?.textContent); } catch (_) { return null; } };
  const shuffled = values => {
    const result = values.slice();
    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  };
  const previous = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } };
  const remember = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const fixedIds = () => new Set([...document.querySelectorAll('[data-ll-home-fixed-project]')].map(node => idFor(node.dataset.llHomeFixedProject)).filter(Boolean));
  const merchIds = () => new Set([...document.querySelectorAll('[data-ll-merch-card][data-ll-home-project]')].map(node => node.dataset.llHomeProject));
  const serviceReservations = () => {
    const ids = new Set();
    document.querySelectorAll('[data-ll-service-project]').forEach(node => {
      [node.dataset.llServiceProject, node.dataset.llServicePendingProject, node.dataset.llServicePreviousProject].forEach(id => { if (id) ids.add(id); });
    });
    return ids;
  };
  const serviceIds = () => {
    const ids = new Set();
    document.querySelectorAll('[data-ll-service-image-data]').forEach(node => {
      const pool = parse(node)?.merchandise;
      if (Array.isArray(pool)) pool.forEach(entry => { if (entry?.id) ids.add(entry.id); });
    });
    return ids;
  };
  const heroPool = (pool, kind) => {
    const blocked = new Set([...fixedIds(), ...serviceIds(), ...serviceReservations(), ...merchIds()]);
    const selector = kind === 'video' ? '[data-ll-home-active-project]' : '[data-ll-home-experience-project]';
    document.querySelectorAll(selector).forEach(node => {
      const id = kind === 'video' ? node.dataset.llHomeActiveProject : idFor(node.dataset.llHomeExperienceProject);
      if (id) blocked.add(id);
    });
    return pool.filter(entry => !blocked.has(entry.id));
  };
  const servicePool = (pool, card = null) => {
    const blocked = new Set([...fixedIds(), ...merchIds()]);
    document.querySelectorAll('[data-ll-hero-project]').forEach(node => blocked.add(node.dataset.llHeroProject));
    document.querySelectorAll('[data-ll-home-experience-project]').forEach(node => blocked.add(idFor(node.dataset.llHomeExperienceProject)));
    document.querySelectorAll('[data-ll-service-project]').forEach(node => {
      if (node === card) return;
      [node.dataset.llServiceProject, node.dataset.llServicePendingProject, node.dataset.llServicePreviousProject].forEach(id => { if (id) blocked.add(id); });
    });
    return pool.filter(entry => !blocked.has(entry.id));
  };
  const initialService = (key, pool) => {
    const stored = servicePlans.get(key);
    const retained = pool.find(entry => entry.id === stored);
    if (retained) return retained;
    const storageKey = 'll:services:last:v2:' + key;
    const last = previous(storageKey);
    const chosen = shuffled(pool.filter(entry => entry.id !== last))[0] || pool[0];
    if (chosen) { servicePlans.set(key, chosen.id); remember(storageKey, chosen.id); }
    return chosen;
  };
  const rememberService = (key, id) => { servicePlans.set(key, id); remember('ll:services:last:v2:' + key, id); };
  const initialExperience = (section, panels) => {
    const active = section.dataset.llHomeActiveProject || experiencePlans.get(section.getAttribute('aria-labelledby'));
    const films = new Set([...document.querySelectorAll('[data-ll-hero-film]')].map(node => node.dataset.llHeroProject));
    let index = panels.findIndex(panel => idFor(panel.dataset.llHomeExperienceProject) === active && !films.has(active));
    if (index < 0) index = panels.findIndex(panel => !films.has(idFor(panel.dataset.llHomeExperienceProject)));
    return Math.max(0, index);
  };
  const selectExperience = (section, panel) => {
    const id = idFor(panel.dataset.llHomeExperienceProject);
    if (!id) return;
    window.LimitlessHeroMedia?.avoid(id);
    section.dataset.llHomeActiveProject = id;
    experiencePlans.set(section.getAttribute('aria-labelledby'), id);
  };
  const safeURL = value => {
    try { return typeof value === 'string' && Boolean(value) && ['http:', 'https:'].includes(new URL(value, document.baseURI).protocol); } catch (_) { return false; }
  };
  const init = (scope = document) => {
    const sections = [...(scope.matches?.('[data-ll-merch-projects]') ? [scope] : []), ...scope.querySelectorAll('[data-ll-merch-projects]')];
    sections.forEach(section => {
      if (controllers.has(section)) return;
      const cards = [...section.querySelectorAll('[data-ll-merch-card]')];
      const data = parse(section.querySelector('[data-ll-merch-project-data]'));
      const seen = new Set(), fixed = new Set([...fixedIds(), ...serviceReservations(), ...[...document.querySelectorAll('[data-ll-hero-project]')].map(node => node.dataset.llHeroProject)]);
      const pool = (Array.isArray(data) ? data : []).filter(entry => {
        if (!entry || idFor(entry.caseLink) !== entry.id || !entry.title || !entry.service || !entry.category || !entry.alt || !safeURL(entry.src) || !(entry.width > 0 && entry.height > 0) || seen.has(entry.id) || fixed.has(entry.id)) return false;
        seen.add(entry.id); return true;
      });
      if (!cards.length || pool.length < cards.length || cards.some(card => !card.querySelector('.ll-feature-card__media img'))) return;
      const key = 'll:merch:last:v2:' + section.dataset.llMerchProjects;
      const old = plans.get(key), last = previous(key), used = new Set();
      const eligible = shuffled(pool);
      const plan = cards.map((card, index) => {
        const retained = eligible.find(entry => entry.id === old?.[index] && !used.has(entry.id));
        const chosen = retained || eligible.find(entry => !used.has(entry.id) && entry.id !== last?.[index]) || eligible.find(entry => !used.has(entry.id));
        used.add(chosen.id); return chosen.id;
      });
      if (!old && Array.isArray(last) && plan.slice().sort().join('|') === last.slice().sort().join('|')) {
        const alternate = eligible.find(entry => !used.has(entry.id));
        if (alternate) plan[plan.length - 1] = alternate.id;
      }
      plans.set(key, plan); remember(key, plan);
      const controller = new AbortController(), failed = new Set();
      controllers.set(section, controller);
      const apply = (card, entry) => {
        const image = card.querySelector('.ll-feature-card__media img');
        card.dataset.llHomeProject = entry.id;
        card.querySelectorAll('a').forEach(link => { link.href = entry.caseLink; if (link.hasAttribute('aria-label')) link.setAttribute('aria-label', entry.title + ': view project'); });
        card.querySelector('h3 a').textContent = entry.title;
        card.querySelector('.ll-feature-card__copy .ll-eyebrow').textContent = entry.service;
        card.querySelector('.ll-feature-card__category').textContent = entry.category;
        const description = card.querySelector('.ll-feature-card__copy > p:not(.ll-eyebrow)');
        if (description) description.textContent = entry.description || '';
        image.alt = entry.alt; image.width = entry.width; image.height = entry.height;
        if (entry.srcset) image.srcset = entry.srcset; else image.removeAttribute('srcset');
        image.src = entry.src;
      };
      cards.forEach((card, index) => {
        const image = card.querySelector('.ll-feature-card__media img');
        image.addEventListener('error', () => {
          failed.add(plan[index]);
          const occupied = new Set([...plan, ...fixedIds(), ...serviceReservations(), ...[...document.querySelectorAll('[data-ll-hero-project]')].map(node => node.dataset.llHeroProject)]);
          const next = pool.find(entry => !occupied.has(entry.id) && !failed.has(entry.id));
          if (!next) return;
          plan[index] = next.id; remember(key, plan); apply(card, next);
        }, {signal: controller.signal});
        apply(card, pool.find(entry => entry.id === plan[index]));
      });
    });
  };
  const destroy = scope => controllers.forEach((controller, section) => {
    if (scope === document || scope === section || scope.contains(section)) { controller.abort(); controllers.delete(section); }
  });
  window.LimitlessHomeProjects = {init, destroy, idFor, heroPool, servicePool, initialService, rememberService, initialExperience, selectExperience};
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true}); else init();
})();
